import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class ConfigurationComponent implements OnInit {
    constructor(private readonly router: Router) {}

    ngOnInit(): void {
        this.router.navigate(['configuration/customization']);
    }
}
